import { Door, Mutation } from 'graphql/generated/graphqlTypes';
import { generateMockDoor } from 'mocks/graphqlMocks/door';
import { removeFields } from 'mocks/graphqlMocks/removeFields';

export function mockedUpdateDoorData(updateDoor: Door): Pick<Mutation, 'updateDoor'> {
  return {
    updateDoor
  };
}

export function mockedUpdateDoorWithOfficeModeData(updateDoor: Door): Pick<Mutation, 'updateDoor'> {
  return {
    updateDoor
  };
}

const fieldsToRemoveFromDoor: (keyof Door)[] = ['locations', 'locationIds', 'taReaderId', 'supportsOssCards'];

export const mockedUpdateDoorDataForMutation = mockedUpdateDoorData(
  removeFields(
    generateMockDoor({
      id: 'mockedDoorId0',
      name: 'mockedDoorNameUpdated'
    }),
    fieldsToRemoveFromDoor
  )
);

export const mockedUpdateDoorWithOfficeModeDataForMutation = mockedUpdateDoorWithOfficeModeData(
  removeFields(
    generateMockDoor({
      id: 'mockedDoorId0',
      name: 'mockedDoorNameUpdated'
    }),
    fieldsToRemoveFromDoor
  )
);

export const mockedUpdateDoorWithOfficeModeAndDoorGroupDataForMutation = mockedUpdateDoorWithOfficeModeData(
  generateMockDoor({
    id: 'mockedDoorId1',
    name: 'mockedDoorNameUpdated'
  })
);

export const mockedUpdateDoorInfoDataForMutation = mockedUpdateDoorData(
  generateMockDoor({
    id: 'mockedDoorId0',
    name: 'door 0'
  })
);
